export function downloadFile(data, filename, mimeType = 'application/octet-stream') {
  let blob;

  if (typeof data === 'string') {
    blob = new Blob([data], { type: mimeType });
  } else if (data instanceof Blob) {
    blob = data;
  } else {
    console.error('Invalid data type for download');
    return;
  }

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}